import { Injectable } from '@angular/core'
import { DataService } from '@vendure/admin-ui/core'

import { GetNextOpenSanctionsStatesDocument, TransitionOpenSanctionsToStateDocument } from '../generated/ui-types'

@Injectable()
export class OpensanctionsStateDataService {
    constructor(private dataService: DataService) {}

    getNextStates(id: string) {
        return this.dataService.query(GetNextOpenSanctionsStatesDocument, {
            id,
        })
    }

    transitionToState(id: string, state: string) {
        return this.dataService.mutate(TransitionOpenSanctionsToStateDocument, {
            id,
            state,
        })
    }
}
